export default {
    inquiryAndAttendance: 'Inquiry & Attendance',
    inquiry: 'Inquiry',
    statusAttendance: 'Status Attendance',
    manageAttendance: 'Manage Attendance',
    punchLog: 'Punch Log',
    searchByEmployeeName: 'Search by Employee name, ID',
    search: 'Search',
    employeeId: 'Employee ID',
    employeeName: 'Employee Name',
    bureau: 'Bureau',
    position: 'Position',
    submittedDate: 'Request date',
    date: 'Date',
    inquiryText: 'Inquiry',
    status: 'Status',
    action: '',
    congratulation: 'Congratulation',
    cannotEditTheApproval: 'Cannot edit the approval inquiry',
    cannotEditTheRejected: 'Cannot edit the rejected inquiry'
}
